import { Component, OnInit } from '@angular/core';
import { HttpModule } from '@angular/http';
import { Validators, FormGroup, FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { FlashMessagesService } from 'angular2-flash-messages';

// Services
import { PriceInsertService } from '../../service/price-insert/price-insert.service';

@Component({
	selector: 'app-price-insert',
	templateUrl: './price-insert.component.html',
	providers: [
		PriceInsertService,
		HttpModule
	]
})
export class PriceInsertComponent implements OnInit {

	private token;
	public permissoes: any[] = [];
	priceForm: FormGroup;

	constructor(fb: FormBuilder, private priceInsertService: PriceInsertService, private flashMessagesService: FlashMessagesService, private router: Router) {
		this.token = localStorage.getItem('yara.token');
		this.priceForm = fb.group({
			'Nome': [null, Validators.compose([Validators.required, Validators.maxLength(120)])],
			'Peso': [null, Validators.compose([Validators.required, Validators.maxLength(120)])],
			'Valor': [null, Validators.compose([Validators.required, Validators.maxLength(120)])],
			'Ativo': ''
		});
	}

	ngOnInit() {
		this.permissoes = localStorage.getItem('yara.permissions') ? JSON.parse(localStorage.getItem('yara.permissions')) : [];
	}

	addPrice(value: any) {
		this.priceInsertService.insertPrice(this.token, value).subscribe(result => {
			if (result.Success) {
				this.flashMessagesService.show('Média Saca editada com sucesso', { cssClass: 'alert-success', timeout: 6000 });
				this.router.navigateByUrl('/media-saca');
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
			
		});
	}

	cancelInsertEdit() {
		this.router.navigateByUrl('/media-saca');
	}

}



// WEBPACK FOOTER //
// ./src/app/price/component/price-insert/price-insert.component.ts